/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class CharItem extends Component {
  render() {
    const { sample_img } = this.props.childProps;

    return (
      <Fragment>
        <div className="div_li">
          <img src={sample_img} />
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(CharItem));
